export const MIN_SLIDER_VALUE = 25000
export const MAX_SLIDER_VALUE = 4000000
